import React from "react";
import "../Styles/ourteam.css";

const teamMembers = [
  {
    id: "team-1",
    name: "Rajeshwaran P",
    role: "Founder & Managing Trustee",
    image: "/assets/Our_team_image_1.png",
    linkedin: "https://www.linkedin.com/in/rajeshwaran-p-🇮🇳-235266141",
  },
  {
    id: "team-2",
    name: "Bharathiraja Thangappalam",
    role: "Managing Trustee",
    image: "/assets/bhararthiraj.jpeg",
    linkedin: "https://www.linkedin.com/in/bharathirajathangappalam" ,
  },
];

const advisoryMembers = [
  {
    id: "advisory-1",
    name: "Uma Maheswari",
    role: "Advisory",
    image: "/assets/Advisiory_cmty_1.png",
    linkedin: "https://www.linkedin.com/in/uma-maheswari-29449035",
  },
  {
    id: "advisory-2",
    name: "Visukumar Gopal",
    role: "Advisory",
    image: "/assets/Advisiory_cmty_2.png",
    linkedin: "https://www.linkedin.com/in/visukumar",
  },
  {
    id: "advisory-3",
    name: "G Siva Sundara Ganesan",
    role: "Advisory",
    image: "/assets/Advisiory_cmty_3.png",
    linkedin: "https://www.linkedin.com/in/siva-gk-32454b92",
  },
  {
    id: "advisory-4",
    name: "Sathya Prakash Sekaran",
    role: "Advisory",
    image: "/assets/Advisiory_cmty_4.png",
    linkedin: "https://www.linkedin.com/in/ssathyaprakash",
  },
  {
    id: "advisory-5",
    name: "Balamurugan",
    role: "Advisory",
    image: "/assets/Advisiory_cmty_5.png",
    linkedin: "https://www.linkedin.com/in/balamrp",
  },
];

// ---- LinkedIn icon (inline SVG so no extra asset is required) ----
const LinkedInIcon = () => (
  <svg
    viewBox="0 0 24 24"
    className="team-linkedin-icon"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.03-1.85-3.03-1.85 0-2.14 1.45-2.14 2.94v5.66H9.36V9h3.41v1.56h.05c.48-.9 1.63-1.85 3.36-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29ZM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12ZM7.12 20.45H3.56V9h3.56v11.45Z" />
  </svg>
);

// ---- Reusable card ------------------------------------------------
const TeamCard = ({ member }) => {
  return (
    <div className="team-card">
      <div className="team-card-image-wrap">
        <img
          src={member.image}
          alt={member.name}
          className="team-card-image"
          loading="lazy"
        />

        {member.linkedin && (
          <a
            href={member.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="team-linkedin-badge"
            aria-label={`${member.name} on LinkedIn`}
            onClick={(e) => e.stopPropagation()}
          >
            <LinkedInIcon />
          </a>
        )}

        <div className="team-card-overlay">
          <h3 className="team-card-name">{member.name}</h3>
          <p className="team-card-role">{member.role}</p>
        </div>
      </div>
    </div>
  );
};

// ---- Main section ---------------------------------------------------
const OurTeam = () => {
  return (
    <section className="our-team-section">
      <div className="our-team-container">
        {/* Our Team */}
        <h2 className="team-heading">
          <span className="team-heading-accent">Our</span> Team
        </h2>

        <div className="team-grid">
          {teamMembers.map((member) => (
            <TeamCard key={member.id} member={member} />
          ))}
        </div>

        {/* Advisory Committee Members */}
        <h2 className="team-heading advisory-heading">
          <span className="team-heading-accent">Advisory Committee</span>{" "}
          Members
        </h2>

        <div className="team-grid advisory-grid">
          {advisoryMembers.map((member) => (
            <TeamCard key={member.id} member={member} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurTeam;